export default __webpack_public_path__ + "static/media/f47-credit-card.b4392010.svg";